import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { showToast } from '../toastMessage/ToastMessage';
import { decryptData } from '@/components/reusable/crypto/Cipher';
import Cookies from 'js-cookie';
import { toWords, toWordsUSD } from '../transactionbill/toWordsConfig';
import {
  billHeaderColumns,
  companyDetail,
} from '../transactionbill/billHeaderColumns';
import { billPageSetting } from '../transactionbill/billPageSettings';
import {
  tableBodyGenerator,
  tableFooterGenerator,
  tableHeadersGenerator,
} from '../transactionbill/billTable';
import dummyImage from '../../assets/images/autologo.png';
import namasterJeweller from '../../assets/images/billFormat/namasterJeweller.jpeg';
import GaneshJi from '../../assets/images/billFormat/ganeshji.png';
import LaxmiJi from '../../assets/images/billFormat/laxmiji.png';

const primaryCalculationType = Cookies.get('primaryCalculationType');

const filterIdOrReferenceId = (data, hiddenKey) => {
  return data?.map((filterData) => {
    return Object.fromEntries(
      Object.entries(filterData).filter(([key, _]) => key !== hiddenKey),
    );
  });
};
const dummyData = {
  ResponseCode: '0',
  response: 'Sales order updated successfully.',
  data: {
    summaryData: {
      purchaseDate: '2025-10-17',
      purchaseDateInNepali: '2082-06-31',
      referenceNumber: null,
      billNumber: 'P/017/2082-2082',
      ledgerName: 'Happy Suppliers',
      ledgerAddress: 'Hakimchwok',
      ledgerMobileNumber: '',
      ledgerPanNumber: '',
      remarks: null,
      voucherData: {
        referenceId: '71aecdbc7f714dbc82c965c40e286620',
        voucherType: 'Payment',
        voucherNo: 'PMT-003-082/83',
        voucherDate: '2025-10-17',
        narration: 'ram pary puyrchase',
        voucherEntries: [
          {
            ledgerId: '4324935b253749d5ae3771346870a728',
            ledgerName: 'Vat pay Bank',
            debitAmount: '0.00',
            creditAmount: '273.00',
            remarks: '135 vat',
            groupName: 'Bank',
          },
          {
            ledgerId: '65f42a750d39476187c25b172104fef3',
            ledgerName: 'nabil bank',
            debitAmount: '0.00',
            creditAmount: '70000.00',
            remarks: 'advance payment',
            groupName: 'Bank',
          },
          {
            ledgerId: '0ce648cd81ce4ff58e61ede686a38131',
            ledgerName: 'Happy Suppliers',
            debitAmount: '70273.00',
            creditAmount: '0.00',
            remarks: '',
            groupName: 'Sundry Creditors',
          },
        ],
        isChange: false,
      },
      isTaxIncluded: false,
      subTotal: 159567.506,
      discountAmount: 557.506,
      luxuryTaxAmount: 0.0,
      luxuryTaxPercent: 0.0,
      vatAmount: 611.0,
      vatPercent: 13.0,
      totalNetWeight: '78.3',
      totalNetWithWastage: '79.2',
      totalPureWeight: '70.1',
      totalDiamondWeight: '2.9',
      totalStoneWeight: '1.5',
      totalDiamondPcs: 5,
      totalStonePcs: 3,
      totalDiamondAmount: '3400',
      totalStoneAmount: '1300',
    },
    detailsData: [
      {
        itemName: '2jor ring',
        itemCode: 'DJR003',
        groupName: 'gold',
        categoryName: '',
        karigarName: '',
        setPcs: 1,
        rate: 2151.0,
        purity: 75.0,
        purityInCarat: '18K',
        grossWeight: 10.7,
        description: '',
        makingChargeType: 'amount',
        makingCharge: 0.0,
        makingAmount: 120.0,
        wastageType: 'w',
        wastageCharge: 0.0,
        wastageWeight: 0.4,
        extraAmount: 10.0,
        subTotal: 19407.8,
        discountAmount: 67.808,
        luxuryTaxAmount: 0.0,
        luxuryTaxPercent: 0.0,
        vatAmount: 325.0,
        vatPercent: 13.0,
        sMakingChargeType: 'amount',
        sMakingCharge: 0.0,
        sMakingAmount: 0.0,
        sWastageType: 'w',
        sWastageCharge: 0.0,
        sWastageWeight: 0.0,
        sExtraAmount: 0.0,
        size: '0',
        referenceCode: '',
        discount: 67.808,
        trayName: '0',
        remarks: '0',
        diamondData: [
          {
            itemName: 'CH',
            pcs: 0,
            unit: 'crt',
            weight: 0.4,
            purchaseRate: 2500.0,
            SalesRate: 4500.0,
            amount: 2500.0,
            salesAmount: 4500.0,
            rateOn: 'bulk',
            hc: null,
            color: null,
            clarity: null,
            cut: null,
          },
        ],
        stoneData: [],
        diamondPcs: 0,
        stonePcs: 0,
        diamondWeight: '0.4 crt',
        stoneWeight: '0 lal',
        diamondAmount: '2500',
        stoneAmount: '0',
        netWeight: '10 lal',
        pureWeight: '7.5 lal',
        netWithWastage: '10.4 lal',
        sNetWeight: '10 lal',
        sPureWeight: '7.5 lal',
        sNetWithWastage: '10 lal',
        sNetAmount: '18632.5',
      },
      {
        itemName: 'Gold Braslet',
        itemCode: 'GOB009',
        groupName: 'gold',
        categoryName: '',
        karigarName: '',
        setPcs: 1,
        rate: 2151.0,
        purity: 91.667,
        purityInCarat: '22K',
        grossWeight: 74.0,
        description: 'test desc',
        makingChargeType: 'amount',
        makingCharge: 0.0,
        makingAmount: 2500.0,
        wastageType: 'w',
        wastageCharge: 0.0,
        wastageWeight: 0.5,
        extraAmount: 0.0,
        subTotal: 140159.706,
        discountAmount: 489.698,
        luxuryTaxAmount: 0.0,
        luxuryTaxPercent: 0.0,
        vatAmount: 286.0,
        vatPercent: 13.0,
        sMakingChargeType: 'amount',
        sMakingCharge: 0.0,
        sMakingAmount: 1200.0,
        sWastageType: 'w',
        sWastageCharge: 0.0,
        sWastageWeight: 0.7,
        sExtraAmount: 200.0,
        size: '4*4',
        referenceCode: 'REF-012',
        discount: 489.698,
        trayName: 'RK-004',
        remarks: 'ok done',
        diamondData: [
          {
            itemName: 'CH',
            pcs: 2,
            unit: 'crt',
            weight: 0.8,
            purchaseRate: 100.0,
            SalesRate: 600.0,
            amount: 200.0,
            salesAmount: 1200.0,
            rateOn: 'pcs',
            hc: null,
            color: null,
            clarity: null,
            cut: null,
          },
          {
            itemName: 'Rd',
            pcs: 1,
            unit: 'crt',
            weight: 0.9,
            purchaseRate: 300.0,
            SalesRate: 800.0,
            amount: 300.0,
            salesAmount: 800.0,
            rateOn: 'pcs',
            hc: '',
            color: '',
            clarity: '',
            cut: '',
          },
          {
            itemName: 'Pn',
            pcs: 2,
            unit: 'crt',
            weight: 0.8,
            purchaseRate: 200.0,
            SalesRate: 700.0,
            amount: 400.0,
            salesAmount: 1400.0,
            rateOn: 'pcs',
            hc: '',
            color: '',
            clarity: '',
            cut: '',
          },
        ],
        stoneData: [
          {
            itemName: 'stone',
            pcs: 2,
            unit: 'crt',
            weight: 0.5,
            purchaseRate: 400.0,
            SalesRate: 900.0,
            amount: 800.0,
            salesAmount: 1800.0,
            rateOn: 'pcs',
            hc: '',
            color: '',
            clarity: '',
            cut: '',
          },
          {
            itemName: 'stone s5',
            pcs: 1,
            unit: 'lal',
            weight: 0.6,
            purchaseRate: 500.0,
            SalesRate: 1000.0,
            amount: 500.0,
            salesAmount: 1000.0,
            rateOn: 'pcs',
            hc: '',
            color: '',
            clarity: '',
            cut: '',
          },
        ],
        diamondPcs: 5,
        stonePcs: 3,
        diamondWeight: '2.5 crt',
        stoneWeight: '1.5 lal',
        diamondAmount: '900',
        stoneAmount: '1300',
        netWeight: '68.3 lal',
        pureWeight: '62.6 lal',
        netWithWastage: '68.8 lal',
        sNetWeight: '68.3 lal',
        sPureWeight: '62.6 lal',
        sNetWithWastage: '69 lal',
        sNetAmount: '139651.233',
      },
    ],
  },
};
export const generateTransactionBill = (
  filteredTableData,
  columns,
  date,
  title,
  voucherNumber,
  party,
  billNumber,
  dataToPut,
  extraDetails = dummyData?.data,
) => {
  const userData = decryptData(localStorage.getItem('userData'));

  const isNamaste = userData?.companyId === 'e4ee585d1e884bdf81adf3f3fd94d90b';
  // const isNamaste = userData?.companyId === 'b231fe7c491943859ae03457c119fe2b';

  extraDetails =
    Object.keys(extraDetails).length > 0 ? extraDetails : dummyData?.data;

  const primaryCalculationType = Cookies.get('primaryCalculationType');
  const { companyDetails } = companyDetail({ userData, date });

  const { columnOne, columnTwo, columnThree } = billHeaderColumns({
    dataToPut,
    customerDetails: extraDetails?.summaryData,
    userData,
    billNumber,
  });
  if (!columns?.length) {
    showToast('No data to export', 'info');
    return;
  }
  filteredTableData = filterIdOrReferenceId(filteredTableData, 'id');

  const doc = new jsPDF({
    orientation: columns?.length > 12 ? 'landscape' : 'portrait',
    compress: true,
  });

  const {
    pageWidth,
    marginTop,
    lineHeight,
    columnHeaderLeftStart,
    columnHeaderTopStart,
    columnHeaderWidth,
    columnHeaderHeight,
    columnContentY,
    pageHeight,
    footerY,
    endRectParamRatio,
    extraSpaceBelowTable,
  } = billPageSetting({ doc });

  const isDiamond = extraDetails?.detailsData?.some(
    (detailItem) => detailItem?.diamondData?.length > 0,
  );
  const isStone = extraDetails?.detailsData?.some(
    (detailItem) => detailItem?.stoneData?.length > 0,
  );
  const isLuxuryTax = extraDetails?.detailsData?.some(
    (detailItem) => detailItem?.luxuryTaxAmount > 0,
  );
  const isVAT = extraDetails?.detailsData?.some(
    (detailItem) => detailItem?.vatAmount > 0,
  );
  const tableBody = tableBodyGenerator(
    extraDetails?.detailsData,
    isDiamond,
    isStone,
    isLuxuryTax,
    isVAT,
    primaryCalculationType,
    isNamaste,
  );
  // Table Header
  const tableHeaders = [columns?.map((column) => column?.title)];

  const tableRows = filteredTableData?.map((item) =>
    columns?.map((column) => item[column?.dataIndex] ?? ''),
  );

  const totals = new Array(columns?.length).fill(0);
  for (let i = 2; i < columns?.length; i++) {
    // Start from index 2 to skip the first two columns
    totals[i] = 0;
  }

  filteredTableData?.forEach((item) => {
    for (let i = 2; i < columns?.length; i++) {
      const value = parseFloat(item[columns[i]?.dataIndex]) || 0;
      totals[i] += value;
    }
  });
  const totalRow = new Array(columns.length).fill('');
  totalRow[0] = 'Total'; // You can change this label
  for (let i = 2; i < columns.length; i++) {
    totalRow[i] = totals[i].toFixed(2); // Format totals as needed
  }
  tableRows.push(totalRow);

  const tableHeaders2 = tableHeadersGenerator(
    isDiamond,
    isStone,
    isLuxuryTax,
    isVAT,
    primaryCalculationType,
    isNamaste,
  );

  // const total =
  //   extraDetails?.detailsData
  //     ?.filter((item) => item?.itemCode !== undefined)
  //     .reduce((acc, item) => {
  //       // return acc + item?.netAmount;
  //       return acc + item?.subTotal;
  //     }, 0) || 0;

  const total = extraDetails?.summaryData?.subTotal || 0;

  const netAmount = extraDetails?.summaryData?.netAmount || 0;

  // const totalLuxuryTax =
  //   extraDetails?.detailsData
  //     ?.filter((item) => item?.itemCode !== undefined)
  //     .reduce((acc, item) => {
  //       // return acc + item?.netAmount;
  //       return acc + item?.luxuryTaxAmount;
  //     }, 0) || 0;

  const totalLuxuryTax = extraDetails?.summaryData?.luxuryTaxAmount || 0;

  // const totalVATAmount =
  //   extraDetails?.detailsData
  //     ?.filter((item) => item?.itemCode !== undefined)
  //     .reduce((acc, item) => {
  //       // return acc + item?.netAmount;
  //       return acc + item?.vatAmount;
  //     }, 0) || 0;

  const totalVATAmount = extraDetails?.summaryData?.vatAmount || 0;

  // const discount =
  //   extraDetails?.detailsData
  //     ?.filter((item) => item?.itemCode !== undefined)
  //     .reduce((acc, item) => {
  //       return acc + item?.discountAmount;
  //     }, 0) || 0;

  const discount = extraDetails?.summaryData?.discountAmount || 0;

  const tableFooter = tableFooterGenerator(
    total,
    extraDetails?.detailsData,
    isDiamond,
    isStone,
    isLuxuryTax,
    isVAT,
    primaryCalculationType,
    isNamaste,
  );

  const rate24K = extraDetails?.detailsData[0]?.rate;
  const outerAutoTable = doc.autoTable({
    startY: 80,
    head: tableHeaders2,
    body: tableBody,
    foot: tableFooter,
    showFoot: 'lastPage',
    theme: 'grid',
    // margin: { left: 100, right: 15 },
    margin: {
      top: marginTop + 11 * lineHeight,
      bottom: 30,
    },
    theme: 'grid',
    styles: {
      fontSize: 9,
      // cellPadding: 1,
      textColor: 0, // Uniform text color
      fillColor: 'white', // Uniform background color
      fontStyle: 'normal',
      halign: 'center',
      valign: 'middle',
      overflow: 'linebreak',
      lineColor: [0, 0, 0],
      lineWidth: 0.05,
      minCellWidth: 12,
    },
    bodyStyles: {
      minCellHeight: isDiamond || isStone ? 10 : 8,
      minCellWidth: 10,
      // lineColor: 255,
    },
    headStyles: {
      fillColor: 'white',
      textColor: 0,
      fontStyle: 'bold',
      lineColor: [0, 0, 0],
      lineWidth: 0.05,
      minCellHeight: isDiamond || isStone ? 1 : 16,
    },
    footStyles: {
      minCellHeight: 12,
      fontStyle: 'bold',
    },
    alternateRowStyles: {
      fillColor: 'white',
    },

    didDrawPage: (data) => {
      // Draw the header
      // doc.setFontSize(14);
      // doc.setFont('helvetica', 'bold');
      // doc.text(`${title} Invoice`.toUpperCase(), pageWidth / 2, marginTop - 5, {
      //   align: 'center',
      // });

      // doc.setFontSize(12);
      // doc.setFont('helvetica', 'normal');
      // doc.text('Rate(24K) :', pageWidth - 65, marginTop + 30, {
      //   align: 'center',
      // });
      // doc.text(
      //   `Nrs. ${rate24K} per ${primaryCalculationType}`,
      //   pageWidth - 33,
      //   marginTop + 30,
      //   {
      //     align: 'center',
      //   },
      // );

      // doc.setFontSize(10);
      // doc.setFont('helvetica', 'normal');
      // doc.setFont('helvetica', 'normal');
      // doc.text(
      //   `PAN No : ${companyDetails.pan}`,
      //   pageWidth / 6,
      //   marginTop + 5 * lineHeight,
      //   {
      //     align: 'left',
      //   },
      // );
      // const companyImage = userData?.companyImage || dummyImage;
      // if (companyImage) {
      //   let format = 'JPEG'; // default

      //   if (companyImage.startsWith('data:image/png')) {
      //     format = 'PNG';
      //   } else if (companyImage.startsWith('data:image/webp')) {
      //     format = 'WEBP';
      //   } else if (
      //     companyImage.startsWith('data:image/jpeg') ||
      //     companyImage.startsWith('data:image/jpg')
      //   ) {
      //     format = 'JPEG';
      //   }

      //   companyImage && doc.addImage(companyImage, format, 10, 12, 30, 30);
      // }
      // // companyImage && doc.addImage(companyImage, 'JPEG', 10, 12, 30, 30);
      // // drawRoundedImageToPDF(userData?.companyImage, doc, 10, 12, 30, 30);

      // doc.setFontSize(14);
      // doc.setFont('helvetica', 'bold');
      // doc.text(
      //   companyDetails?.title?.toUpperCase(),
      //   pageWidth / 6,
      //   marginTop + lineHeight,
      //   {
      //     align: 'center',
      //   },
      // );

      // doc.setFontSize(10);
      // doc.setFont('helvetica', 'normal');
      // doc.text(
      //   companyDetails?.branchInfo,
      //   pageWidth / 6,
      //   marginTop + 2 * lineHeight,
      //   {
      //     align: 'left',
      //   },
      // );
      // doc.text(
      //   `Phone No : ${companyDetails?.phone}`,
      //   pageWidth / 6,
      //   marginTop + 3 * lineHeight,
      //   {
      //     align: 'left',
      //   },
      // );
      // doc.text(
      //   `Email Id : ${companyDetails?.email}`,
      //   pageWidth / 6,
      //   marginTop + 4 * lineHeight,
      //   {
      //     align: 'left',
      //   },
      // );
      // doc.setFontSize(9);
      // doc.setFont('helvetica', 'bold');
      // doc.text(
      //   `Date: ${companyDetails?.date}`,
      //   pageWidth - 15,
      //   marginTop + 10,
      //   {
      //     align: 'right',
      //   },
      // );
      if (!isNamaste) {
        doc.setFontSize(14);
        doc.setFont('helvetica', 'bold');
        doc.text(
          `${title} Invoice`.toUpperCase(),
          pageWidth / 2,
          marginTop - 5,
          {
            align: 'center',
          },
        );
      }

      doc.setFontSize(12);
      doc.setFont('helvetica', 'normal');
      doc.text('Rate(24K) :', pageWidth - 65, marginTop + 30, {
        align: 'center',
      });
      doc.text(
        `${isNamaste ? '$' : 'Nrs.'}  ${(rate24K * (primaryCalculationType === 'lal' ? 100 : 11.664)).toLocaleString('en-US')} per tola`,
        pageWidth - 33,
        marginTop + 30,
        {
          align: 'center',
        },
      );

      if (!isNamaste) {
        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        doc.setFont('helvetica', 'normal');
        doc.text(
          `PAN No : ${userData?.brancPanNumber || userData?.branchPanNumber || companyDetails?.pan || ''}`,
          pageWidth / 2,
          marginTop + 5 * lineHeight,
          {
            align: 'center',
          },
        );
      }
      // const companyImage =
      //   userData?.branchPhoto ||
      //   userData?.companyImage ||
      //   namasterJeweller ||
      //   dummyImage;
      // if (companyImage) {
      //   const boxX = 10;
      //   const boxY = 8;
      //   const boxWidth = 40;
      //   const boxHeight = 40;

      //   const {
      //     fileType,
      //     height: imageHeight,
      //     width: imageWidth,
      //   } = doc.getImageProperties(companyImage);

      //   const imgW = imageWidth;
      //   const imgH = imageHeight;

      //   const imgAspect = imgW / imgH;
      //   const boxAspect = boxWidth / boxHeight;

      //   let drawWidth = boxWidth;
      //   let drawHeight = boxHeight;

      //   // Scale the image to fit (contain behavior)
      //   if (imgAspect > boxAspect) {
      //     drawWidth = boxWidth;
      //     drawHeight = boxWidth / imgAspect;
      //   } else {
      //     drawHeight = boxHeight;
      //     drawWidth = boxHeight * imgAspect;
      //   }

      //   // Center the image inside the box
      //   const offsetX = boxX + (boxWidth - drawWidth) / 2;
      //   const offsetY = boxY + (boxHeight - drawHeight) / 2;

      //   // Draw the scaled and centered image
      //   doc.addImage(
      //     companyImage,
      //     fileType,
      //     offsetX,
      //     offsetY,
      //     drawWidth,
      //     drawHeight,
      //   );
      // }
      // // God Ganesh Ji an Goddess Laxmi Ji images
      // GaneshJi && doc.addImage(GaneshJi, 'JPEG', 60, 10, 30, 30);
      // LaxmiJi && doc.addImage(LaxmiJi, 'JPEG', 210, 10, 30, 30);
      function drawCompanyImage(image, x, y, height, width) {
        if (image) {
          const boxX = 10;
          const boxY = 8;
          const boxWidth = height;
          const boxHeight = width;

          const {
            fileType,
            height: imageHeight,
            width: imageWidth,
          } = doc.getImageProperties(image);

          const imgW = imageWidth;
          const imgH = imageHeight;

          const imgAspect = imgW / imgH;
          const boxAspect = boxWidth / boxHeight;

          let drawWidth = boxWidth;
          let drawHeight = boxHeight;

          // Scale the image to fit (contain behavior)
          if (imgAspect > boxAspect) {
            drawWidth = boxWidth;
            drawHeight = boxWidth / imgAspect;
          } else {
            drawHeight = boxHeight;
            drawWidth = boxHeight * imgAspect;
          }

          // // Center the image inside the box
          // const offsetX = boxX + (boxWidth - drawWidth) / 2;
          // const offsetY = boxY + (boxHeight - drawHeight) / 2;

          // Draw the scaled and centered image
          doc.addImage(
            image,
            fileType,
            x,
            y,
            drawWidth,
            drawHeight,
            '',
            'FAST',
          );
        }
      }
      const dynamicPhoto = isNamaste
        ? namasterJeweller
        : userData?.branchPhoto || userData?.companyImage || dummyImage;
      const companyImage = dynamicPhoto;

      !isNamaste && drawCompanyImage(companyImage, 10, 15, 40, 40);
      !isNamaste && GaneshJi && drawCompanyImage(GaneshJi, 60, 3, 35, 35);
      !isNamaste && LaxmiJi && drawCompanyImage(LaxmiJi, 200, 3, 35, 35);

      isNamaste &&
        drawCompanyImage(companyImage, pageWidth / 2 - 20, 4, 40, 40);
      isNamaste && GaneshJi && drawCompanyImage(GaneshJi, 60, 3, 35, 35);
      isNamaste && LaxmiJi && drawCompanyImage(LaxmiJi, 200, 3, 35, 35);

      if (isNamaste) {
        doc.setFontSize(12);
        doc.setFont('helvetica', 'bold');
        doc.text('ABN 88 631 618 721', 260, 10, {
          align: 'center',
        });
        doc.setFontSize(10);
        doc.setFont('helvetica', 'semibold');
        doc.text(
          // `Phone No : ${userData?.branchNumber || companyDetails?.phone || ''}`,
          `Phone Number : 0430 303 1813`,
          pageWidth / 2,
          marginTop + 5 + 3 * lineHeight,
          {
            align: 'center',
          },
        );
        doc.text(
          // `Phone No : ${userData?.branchNumber || companyDetails?.phone || ''}`,
          `02 8057 9743`,
          pageWidth / 2 + 5,
          marginTop + 9 + 3 * lineHeight,
          {
            align: 'center',
          },
        );

        doc.setFontSize(10);
        doc.setFont('helvetica', 'semibold');
        doc.text(
          // `Email Id : ${userData?.branchEmail || companyDetails?.email || ''}`,
          `Email Id : namastejewellers1@gmail.com`,
          pageWidth / 2,
          marginTop + 7 + 4 * lineHeight,
          {
            align: 'center',
          },
        );
        doc.setFontSize(9);
        doc.setFont('helvetica', 'bold');
        doc.text(
          `Date: ${companyDetails?.date}`,
          pageWidth - 15,
          marginTop + 10,
          {
            align: 'right',
          },
        );
      }

      if (!isNamaste) {
        doc.setFontSize(14);
        doc.setFont('helvetica', 'bold');
        doc.text(
          userData?.companyName?.toUpperCase() ||
            companyDetails?.title?.toUpperCase() ||
            '',
          pageWidth / 2,
          marginTop + lineHeight,
          {
            align: 'center',
          },
        );

        doc.setFontSize(10);
        doc.setFont('helvetica', 'normal');
        doc.text(
          userData?.branchName,
          pageWidth / 2,
          marginTop + 2 * lineHeight,
          {
            align: 'center',
          },
        );
        doc.text(
          `Phone No : ${userData?.branchNumber || companyDetails?.phone || ''}`,
          pageWidth / 2,
          marginTop + 3 * lineHeight,
          {
            align: 'center',
          },
        );
        doc.text(
          `Email Id : ${userData?.branchEmail || companyDetails?.email || ''}`,
          pageWidth / 2,
          marginTop + 4 * lineHeight,
          {
            align: 'center',
          },
        );
        doc.setFontSize(9);
        doc.setFont('helvetica', 'bold');
        doc.text(
          `Date: ${companyDetails?.date}`,
          pageWidth - 15,
          marginTop + 10,
          {
            align: 'right',
          },
        );
      }
      //Column Section
      /**
       * Make a rectangular box where header columns are placed
       * setLinewidth -> sets the width of the line of the rectangular box
       * rect(leftStart, topStart, width , height)
       * line(startXPosition, startYPoisition, EndXPosition, EndyPosition )
       */
      doc.setLineWidth(0.1);
      doc.rect(
        columnHeaderLeftStart,
        columnHeaderTopStart,
        columnHeaderWidth,
        columnHeaderHeight,
      );
      doc.line(
        (pageWidth * 1) / 2,
        columnHeaderTopStart,
        (pageWidth * 1) / 2,
        columnHeaderTopStart + columnHeaderHeight,
      );
      doc.line(
        (pageWidth * 3) / 4,
        columnHeaderTopStart,
        (pageWidth * 3) / 4,
        columnHeaderTopStart + columnHeaderHeight,
      );

      doc.setFontSize(8);
      doc.setFont('helvetica', 'normal');

      // Column First for customer name and other details
      columnOne.forEach((row, index) => {
        const y = columnContentY + (index + 1) * lineHeight;
        const labelWidth = doc.getTextWidth(row.label);
        doc.text(row.label.toUpperCase(), 16, y, {
          align: 'left',
        });
        doc.text(':', 45, y);
        doc.text(row.value.toUpperCase(), 55, y);
      });

      //Column Second for counter details
      columnTwo.forEach((row, index) => {
        const y = columnContentY + (index + 1) * lineHeight;
        const labelWidth = doc.getTextWidth(row.label);
        doc.text(row.label.toUpperCase(), (pageWidth * 1) / 2 + 5, y, {
          align: 'left',
        });
        doc.text(':', (pageWidth * 1) / 2 + 35, y);
        doc.text(row.value.toUpperCase(), (pageWidth * 1) / 2 + 35, y);
      });

      //Column Third for Invoice Details
      columnThree.forEach((row, index) => {
        const y = columnContentY + (index + 1) * lineHeight;
        const labelWidth = doc.getTextWidth(row.label);
        doc.text(row.label.toUpperCase(), (pageWidth * 3) / 4 + 5, y, {
          align: 'left',
        });
        doc.text(':', (pageWidth * 3) / 4 + 30, y);
        doc.text(row.value.toUpperCase(), (pageWidth * 3) / 4 + 35, y);
      });

      const footerText = 'DipArtha';
      const footerTextWidth = doc.getTextWidth(footerText);
      doc.text(
        footerText,
        (pageWidth - footerTextWidth) / 2, // Center the text horizontally
        pageHeight - 2, // Position it near the bottom of the page
      );
    },
  });

  //table width
  const tableWidth = outerAutoTable.lastAutoTable.columns.reduce(
    (acc, col) => acc + col.width,
    0,
  );

  /**
   *  end of Rect calculate the width of discount and net total rectangle section
   *  for eg:
   * If page width = 100
   *  table width = 80
   * (table width) - 1/5 * table width -> starting position of the rectanlge (set manullay to be there)
   * => 80 - 1/5 * 80 => 64
   * (pagewidth - tablewidth)/2 => the margin of the autotable , taking half of it will give the end spaces after the table on x-axis
   * (100 - 80) /2 => 10
   * so endOfRect = 100 - 64 -10 => 26 => width of the rect
   */
  const endOfRect =
    pageWidth -
    (tableWidth - endRectParamRatio * tableWidth) -
    (pageWidth - tableWidth) / 2;
  const placeFooterTotalsSection = () => {
    const finalY = doc.lastAutoTable.finalY;
    const neededSpace = 55; // Estimate how much vertical space you need (e.g. totals + signature)

    if (finalY + neededSpace > pageHeight - 20) {
      doc.addPage();
      return 30; // startY on new page
    } else {
      return finalY; // continue below table
    }
  };

  const footerYSpace = placeFooterTotalsSection();

  //subtotal section
  doc.setLineWidth(0.1);
  doc.rect(14, footerYSpace + 4, 160, 24);

  doc.rect(
    tableWidth - endRectParamRatio * tableWidth,
    footerYSpace + extraSpaceBelowTable,
    endOfRect,
    8,
  );
  doc.line(
    tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth,
    footerYSpace + extraSpaceBelowTable,
    tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth,
    footerYSpace + 8 + extraSpaceBelowTable,
  );
  // Prepare the text
  const words = isNamaste
    ? // ? `IN WORDS : ${toWordsUSD.convert((total - discount + totalLuxuryTax + totalVATAmount).toFixed(3))}`
      `IN WORDS : ${toWordsUSD.convert(netAmount.toFixed(3))}`
    : // : `IN WORDS : ${toWords.convert((total - discount + totalLuxuryTax + totalVATAmount).toFixed(3))}`;
      `IN WORDS : ${toWords.convert(netAmount.toFixed(3))}`;

  // Split into lines if it’s long
  const wrappedText = doc.splitTextToSize(words, 200); // 155 is width (change if needed)
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text(
    // `IN WORDS : ${toWords.convert((total - discount).toFixed(3))}`,
    wrappedText,
    18,
    footerYSpace + 12,
    { align: 'left' },
  );
  doc.text(
    `Sub Total`,
    tableWidth - endRectParamRatio * tableWidth + 4,
    footerYSpace + 5.5 + extraSpaceBelowTable,
    {
      align: 'left',
    },
  );
  doc.text(
    `${isNamaste ? '$' : 'Nrs.'} ${Number(total.toFixed(3)).toLocaleString(isNamaste ? 'en-US' : 'en-In')}  /-`,
    tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth + 2,
    footerYSpace + 5.5 + extraSpaceBelowTable,
    {
      align: 'left',
    },
  );
  // discount section
  doc.setLineWidth(0.1);

  doc.rect(
    tableWidth - endRectParamRatio * tableWidth,
    footerYSpace + 8 + extraSpaceBelowTable,
    endOfRect,
    8,
  );
  doc.line(
    tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth,
    footerYSpace + 8 + extraSpaceBelowTable,
    tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth,
    footerYSpace + 16 + extraSpaceBelowTable,
  );
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text(
    `Discount`,
    tableWidth - endRectParamRatio * tableWidth + 4,
    footerYSpace + 14 + extraSpaceBelowTable,
    {
      align: 'left',
    },
  );
  doc.text(
    `${isNamaste ? '$' : 'Nrs.'} ${Number(discount.toFixed(3)).toLocaleString(isNamaste ? 'en-US' : 'en-In')}  /-`,
    tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth + 2,
    footerYSpace + 14 + extraSpaceBelowTable,
    {
      align: 'left',
    },
  );

  let dynamicSpace = footerYSpace + 8 + extraSpaceBelowTable;

  if (isNamaste) {
    // GST
    doc.setLineWidth(0.1);
    doc.rect(
      tableWidth - endRectParamRatio * tableWidth,
      footerYSpace + 24 + extraSpaceBelowTable,
      endOfRect,
      8,
    );
    doc.line(
      tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth,
      footerYSpace + 24 + extraSpaceBelowTable,
      tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth,
      footerYSpace + 32 + extraSpaceBelowTable,
    );
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text(
      `GST`,
      tableWidth - endRectParamRatio * tableWidth + 4,
      footerYSpace + 22 + extraSpaceBelowTable,
      {
        align: 'left',
      },
    );
  }

  const heightOfNetTotal = isNamaste ? 30 : 22;
  if (totalLuxuryTax) {
    doc.setLineWidth(0.1);
    doc.rect(
      tableWidth - endRectParamRatio * tableWidth,
      dynamicSpace + 8,
      endOfRect,
      8,
    );
    doc.line(
      tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth,
      dynamicSpace + 8,
      tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth,
      dynamicSpace + 16,
    );
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text(
      `Lux. Tax (${extraDetails?.summaryData?.luxuryTaxPercent}%)`,
      tableWidth - endRectParamRatio * tableWidth + 4,
      dynamicSpace + heightOfNetTotal - 8,
      {
        align: 'left',
      },
    );
    doc.text(
      `${isNamaste ? '$' : 'Nrs.'} ${Number(totalLuxuryTax.toFixed(3)).toLocaleString(isNamaste ? 'en-US' : 'en-In')} /-`,
      tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth + 2,
      dynamicSpace + heightOfNetTotal - 8,
      {
        align: 'left',
      },
    );

    dynamicSpace = dynamicSpace + 8;
  }
  if (totalVATAmount) {
    // VAT Amount
    doc.setLineWidth(0.1);
    doc.rect(
      tableWidth - endRectParamRatio * tableWidth,
      dynamicSpace + 8,
      endOfRect,
      8,
    );
    doc.line(
      tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth,
      dynamicSpace + 8,
      tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth,
      dynamicSpace + 16,
    );
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.text(
      `VAT (${extraDetails?.summaryData?.vatPercent}%)`,
      tableWidth - endRectParamRatio * tableWidth + 4,
      dynamicSpace + heightOfNetTotal - 8,
      {
        align: 'left',
      },
    );
    doc.text(
      `${isNamaste ? '$' : 'Nrs.'} ${Number(totalVATAmount.toFixed(3)).toLocaleString(isNamaste ? 'en-US' : 'en-In')} /-`,
      tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth + 2,
      dynamicSpace + heightOfNetTotal - 8,
      {
        align: 'left',
      },
    );
    dynamicSpace = dynamicSpace + 8;
  }
  // }

  // Net Total
  doc.setLineWidth(0.1);
  doc.rect(
    tableWidth - endRectParamRatio * tableWidth,
    dynamicSpace + 8,
    endOfRect,
    8,
  );
  doc.line(
    tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth,
    dynamicSpace + 8,
    tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth,
    dynamicSpace + 16,
  );
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text(
    `Net Total`,
    tableWidth - endRectParamRatio * tableWidth + 4,
    dynamicSpace + heightOfNetTotal - 8,
    {
      align: 'left',
    },
  );
  doc.text(
    // `${isNamaste ? '$' : 'Nrs.'} ${Number((total - discount + totalLuxuryTax + totalVATAmount).toFixed(3)).toLocaleString(isNamaste ? 'en-US' : 'en-In')} /-`,
    `${isNamaste ? '$' : 'Nrs.'} ${Number(netAmount).toLocaleString(isNamaste ? 'en-US' : 'en-In')} /-`,
    tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth + 2,
    dynamicSpace + heightOfNetTotal - 8,
    {
      align: 'left',
    },
  );
  dynamicSpace = dynamicSpace + 8;
  //Due Amount
  // doc.setLineWidth(0.1);
  // doc.rect(
  //   tableWidth - endRectParamRatio * tableWidth,
  //   footerYSpace + 24 + extraSpaceBelowTable,
  //   endOfRect,
  //   8,
  // );
  // doc.line(
  //   tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth,
  //   footerYSpace + 24 + extraSpaceBelowTable,
  //   tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth,
  //   footerYSpace + 32 + extraSpaceBelowTable,
  // );
  // doc.setFontSize(10);
  // doc.setFont('helvetica', 'bold');
  // doc.text(
  //   `Balance`,
  //   tableWidth - endRectParamRatio * tableWidth + 4,
  //   footerYSpace + 30 + extraSpaceBelowTable,
  //   {
  //     align: 'left',
  //   },
  // );
  // doc.text(
  //   `$ ${Number((total - discount).toFixed(3)).toLocaleString('en-US')} /-`,
  //   tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth + 2,
  //   footerYSpace + 30 + extraSpaceBelowTable,
  //   {
  //     align: 'left',
  //   },
  // );

  // // Balance
  // doc.setLineWidth(0.1);
  // doc.rect(
  //   tableWidth - endRectParamRatio * tableWidth,
  //   footerYSpace + 32 + extraSpaceBelowTable,
  //   endOfRect,
  //   8,
  // );
  // doc.line(
  //   tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth,
  //   footerYSpace + 32 + extraSpaceBelowTable,
  //   tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth,
  //   footerYSpace + 40 + extraSpaceBelowTable,
  // );
  // doc.setFontSize(10);
  // doc.setFont('helvetica', 'bold');
  // doc.text(
  //   `Due Amount`,
  //   tableWidth - endRectParamRatio * tableWidth + 4,
  //   footerYSpace + 38 + extraSpaceBelowTable,
  //   {
  //     align: 'left',
  //   },
  // );
  // doc.text(
  //   `$ ${Number((total - discount).toFixed(3)).toLocaleString('en-US')} /-`,
  //   tableWidth - ((endRectParamRatio * 1) / 1.5) * tableWidth + 2,
  //   footerYSpace + 38 + extraSpaceBelowTable,
  //   {
  //     align: 'left',
  //   },
  // );
  // Footer section

  doc.setFontSize(9);
  doc.setFont('helvetica', 'bold');

  // Calculate positions for horizontal alignment
  const preparedByX = 15; // Starting position for "Prepared by"
  const footerYHorizontal = dynamicSpace - 10; // Y-position below the table and line

  doc.setFontSize(10);
  doc.text('Please Note:', 15, footerYHorizontal + 25);

  doc.setFontSize(8);
  doc.text(
    'A. Deductions apply to chemicals, waste & labour charges on sale or exchange of jewellery.',
    15,
    footerYHorizontal + 30,
  );
  doc.text(
    'B. Waste (jarti) refers to loss incurred during jewellery making.',
    15,
    footerYHorizontal + 35,
  );
  doc.text(
    'C. Always verify the weight of jewellery when buying or selling.',
    15,
    footerYHorizontal + 40,
  );
  doc.text(
    'D. Invoice is required as proof of purchase before we buy back jewellery.',
    15,
    footerYHorizontal + 45,
  );
  doc.text(
    'E. Exchanges accepted within 14 days with proof of purchase. no refunds for change of mind.',
    15,
    footerYHorizontal + 50,
  );
  doc.text('"error & omissions accepted"', 15, footerYHorizontal + 60);

  if (isNamaste) {
    doc.setFontSize(11);
    doc.text('Thank you!', preparedByX + 225, footerYHorizontal + 50, {
      align: 'left',
    });
    doc.text(
      'Signed by Seller: ______________________',
      preparedByX + 135,
      footerYHorizontal + 50,
      {
        align: 'left',
      },
    );
  }

  if (!isNamaste) {
    doc.text(
      'Received by: ______________________',
      preparedByX + 215,
      footerYHorizontal + 60,
      {
        align: 'left',
      },
    );
    doc.text(
      'Prepared by: ______________________',
      preparedByX + 135,
      footerYHorizontal + 60,
      {
        align: 'left',
      },
    );
  }

  // Open PDF in new tab
  doc.output('dataurlnewwindow');
};
